// Mirror of apps/backend/src/services/flow/utils/constants.js — keep in sync manually.
export const MUST_CONTINUE_TYPES = new Set(['botAsks', 'condition', 'ifCondition', 'userSays', 'waitForUserReply', 'intentVerifier', 'input']);
